<template>
  <div>
    <h2>
      <v-icon color="accent">{{icono}}</v-icon>
      {{titulo}}
    </h2>
    <br>
    <v-form v-model="valid" ref="form">
    <v-layout row wrap>
      <v-flex xs12 sm10 md10 lg10 class="pr-2">
        <v-layout row wrap>
          <v-flex xs2 sm2 md2 lg2>
            <strong class="mr-1">ID</strong>
          </v-flex>
          <v-flex xs6 sm6 md6 lg6>
            <strong>{{ registro.id}}</strong>
          </v-flex>
        </v-layout>
        <v-radio-group v-model="registro.tipo">
          <v-radio
            v-for="n in ['PERSONA FISICA', 'PERSONA MORAL']"
            :key="n"
            :label="`${n}`"
            :value="n"
          ></v-radio>
        </v-radio-group>
        <v-text-field
          :label="labelNombre"
          v-model="registro.nombre"
          :rules="nameRules"
          :counter="50"
          required
        ></v-text-field>
        <v-text-field v-if="registro.tipo == 'PERSONA FISICA'"
          label="Apellido Paterno"
          v-model="registro.apellidoPaterno"
          :rules="nameRules"
          required
        ></v-text-field>
        <v-text-field v-if="registro.tipo == 'PERSONA FISICA'"
          label="Apellido Materno"
          v-model="registro.apellidoMaterno"
          :rules="nameRules"
          required
        ></v-text-field>
        <v-radio-group v-model="registro.genero" v-if="registro.tipo == 'PERSONA FISICA'">
          <v-radio
            v-for="n in ['MASCULINO', 'FEMENINO']"
            :key="n"
            :label="`${n}`"
            :value="n" required>
          </v-radio>
        </v-radio-group>

        <v-text-field
          label="RFC" :rules="rfcRules"
          v-model="registro.rfc" :counter="16" maxlength="16"
        ></v-text-field>

        <h3 v-show="registro.tipo == 'PERSONA MORAL'">Persona de Contacto</h3>
        <div v-if="registro.tipo == 'PERSONA MORAL'">
          <v-text-field
            label="Nombre"
            v-model="registro.personaContacto.nombre"
            required :rules="nameRules"
          ></v-text-field>
          <v-text-field
            label="Apellido Paterno"
            v-model="registro.personaContacto.apellidoPaterno"
            required :rules="nameRules"
          ></v-text-field>
          <v-text-field
            label="Apellido Materno"
            v-model="registro.personaContacto.apellidoMaterno"
            required :rules="nameRules"
          ></v-text-field>
          <v-radio-group v-model="registro.personaContacto.genero">
            <v-radio
              v-for="n in ['MASCULINO', 'FEMENINO']"
              :key="n"
              :label="`${n}`"
              :value="n" :rules="nameRules">
            </v-radio>
          </v-radio-group>
        </div>

        <v-text-field
          label="Email" :rules="emailRules"
          v-model="registro.email"
        ></v-text-field>
        <v-text-field
          label="Telefono" mask="(###) ### - ####"
          v-model="registro.telefono"
        ></v-text-field>

        <v-checkbox
          label="Activo"
          v-model="registro.activo"
        ></v-checkbox>

        <v-expansion-panel popout>
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon>fas fa-address-card</v-icon>
              Dirección
            </div>
            <v-card>
              <v-card-text>

                <v-text-field
                  label="Pais"
                  v-model="registro.direccion.pais"
                ></v-text-field>
                <v-select
                  :items="estados"
                  v-model="registro.direccion.estado"
                  label="Estado"
                ></v-select>
                <v-text-field
                  label="Calle y número"
                  v-model="registro.direccion.calle"
                  placeholder="Reforma #112"
                ></v-text-field>
                <v-text-field
                  label="Colonia"
                  v-model="registro.direccion.colonia" placeholder="Centro"
                ></v-text-field>
                <v-text-field
                  label="Código Postal"
                  v-model="registro.direccion.codigoPostal"
                  placeholder="03500"
                ></v-text-field>

              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>


        <v-layout row wrap class="mt-3">
          <v-flex xs6 sm4>
            <span class="mr-3">Fecha de Creación</span>
          </v-flex>
          <v-flex xs6 sm5>
            <span class="info--text">{{ registro.fechaCreacion | date}}</span>
          </v-flex>
          <v-flex xs6 sm4>
            <span class="mr-3">Fecha de Actualización</span>
          </v-flex>
          <v-flex xs6 sm5>
            <span class="info--text">{{ registro.fechaActualizacion | date}}</span>
          </v-flex>
          <v-flex xs6 sm4>
            <span class="mr-3">Usuario Creación</span>
          </v-flex>
          <v-flex xs6 sm5>
            <span v-if="registro.usuarioCreacion" class="info--text">{{ registro.usuarioCreacion.username}}</span>
          </v-flex>
          <v-flex xs6 sm4>
            <span class="mr-3">Grupo</span>
          </v-flex>
          <v-flex xs6 sm5>
            <span v-if="registro.group" class="info--text">{{ registro.group.name}}</span>
          </v-flex>
          <v-flex xs6 sm4>
            <span class="mr-3">Propietario</span>
          </v-flex>
          <v-flex xs6 sm5>
            <span v-if="registro.propietario" class="info--text">{{ registro.propietario.username}}</span>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm2 md2 lg2>
        <v-btn
          block
          @click="submit"
          :disabled="!valid"
          color="success"
        >
          <v-icon v-if="accion == 1" small left>fas fa-plus</v-icon>
          <v-icon v-if="accion == 2" small left>fas fa-edit</v-icon>
          <span v-show="accion == 1">Agregar</span>
          <span v-show="accion == 2">Actualizar</span>
        </v-btn>
        <v-btn @click="dialogoEliminar" block color="error" v-show="accion == 2">
          <v-icon left small>fas fa-trash-alt</v-icon>
          Eliminar
        </v-btn>
        <v-btn @click="cancelar" block >
          <v-icon left small>fas fa-chevron-left</v-icon>
          cancelar
        </v-btn>
        <Ownership v-if="accion == 2" :objeto="registro"></Ownership>
      </v-flex>
    </v-layout>
    </v-form>

    <v-dialog v-model="dialog3" max-width="400px">
      <v-card>
        <v-card-title>
          <span>Confirme que desea eliminar el registro</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-actions>
          <v-btn color="error" @click.stop="eliminar()">
            <v-icon left small>fas fa-trash-alt</v-icon>
            Aceptar
          </v-btn>
          <v-btn flat @click.stop="dialog3=false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <br>
    <v-divider></v-divider>
    <br>
    <v-tabs
      v-model="tabActivo"
      color="cyan"
      dark
      slider-color="yellow"
      v-if="accion == 2 && registro.id"
    >
      <v-tab v-for="t in tabs" :key="t.id" ripple>
        {{ t.titulo }}
      </v-tab>
      <v-tab-item :key="1">
        Relación 1
      </v-tab-item>
      <v-tab-item :key="2">
        Relación 2
      </v-tab-item>
    </v-tabs>

  </div>
</template>

<script>
import Clientes from '../../services/clientes'
import Ownership from '../shared/OwnershipComponent'

export default {
  name: 'ClienteDetalle',
  data () {
    return {
      titulo: 'Cliente Detalle',
      icono: 'fas fa-briefcase',
      accion: null,
      dialog3: false,
      registro: { tipo: 'PERSONA FISICA', activo: true, direccion: { pais: null, estado: null, calle: null, colonia: null, codigoPostal: null} },
      valid: true,
      estados: [
        'AGUASCALIENTES',
        'BAJA CALIFORNIA NORTE',
        'BAJA CALIFORNIA SUR',
        'COAHUILA',
        'CHIHUAHUA',
        'COLIMA',
        'CAMPECHE',
        'CHIAPAS',
        'DISTRITO FEDERAL',
        'DURANGO',
        'GUERRERO',
        'GUANAJUATO',
        'HIDALGO',
        'JALISCO',
        'MICHOACAN',
        'MORELOS',
        'MEXICO',
        'NAYARIT',
        'NUEVO LEON',
        'OAXACA',
        'PUEBLA',
        'QUERETARO',
        'QUINTANA ROO',
        'SINALOA',
        'SAN LUIS POTOSI',
        'SONORA',
        'TAMAULIPAS',
        'TABASCO',
        'TLAXCALA',
        'VERACRUZ',
        'YUCATAN',
        'ZACATECAS',
      ],
      tabActivo: null,
      nameRules: [
        v => !!v || 'Este campo es requerido',
        v => (v && v.length <= 100) || 'El campo debe ser menor a 100 caracteres'
      ],
      emailRules: [
        v => !!v || 'Ingrese una dirección de email',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Ingrese una dirección email válida'
      ],
      rfcRules: [
        v => /^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))((-)?([A-Z\d]{3}))?$/.test(v) || 'Ingrese un RFC válido'
      ],
      mensaje: false,
      tabs: [
        {id: 1, titulo: 'Vehiculos'}
      ],
      filtroVehiculos: null
    }
  },
  components: {
    Ownership
  },
  computed: {
    labelNombre: function(){
      return this.registro.tipo === 'PERSONA FISICA' ? 'Nombre' : 'Razón Social'
    }
  },
  watch: {
    'registro.tipo': function(val){
      if (val == 'PERSONA MORAL' && ! this.registro.personaContacto) {
        this.$set(this.registro, 'personaContacto', {nombre: '', apellidoPaterno: '', apellidoMaterno: ''})
      }
    },
    'registro.rfc': function(val){
      this.registro.rfc = val.toUpperCase()
    }
  },
  provide: function () {
    return {
      servicio: Clientes
    }
  },
  methods: {
    async submit () {
      if (this.$refs.form.validate()) {
        if (this.accion === 1) {
          this.registro = await Clientes.save(this.registro)
          this.accion = 2
          this.$emit('show-message', {msg: 'Registro Guardado', tipo: 'success'})
        } else {
          this.registro = await Clientes.update(this.registro)
          this.$emit('show-message', {msg: 'Registro Actualizado', tipo: 'success'})
        }
      }
    },
    async eliminar() {
      await Clientes.delete(this.registro.id)
      this.dialog3 = false
      this.$emit('show-message', 'Registro Eliminado')
      setTimeout(this.cancelar, 800)
    },
    cancelar () {
      this.$router.push('/clientes')
    },
    dialogoEliminar() {
      this.dialog3 = true
    }
  },
  beforeMount: async function() {
    if (this.$route.params.id === '0') {
      this.accion = 1 //Agregar
    } else {
      this.accion = 2 //Actualizar
      this.registro = await Clientes.get(this.$route.params.id, { populate: 'usuarioCreacion,propietario'})
      if (!this.registro) {
        this.cancelar()
      }
      this.filtroVehiculos = { registro: this.registro.id }
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/clientes/ClienteDetalle.vue